import { ArrowDown, ArrowUp, Trash2 } from 'lucide-react';
import { IconTooltipButton } from '@/components/common/IconTooltipButton';

interface ReorderButtonsProps {
  index: number;
  total: number;
  itemLabel: string;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
  disabled?: boolean;
}

export function ReorderButtons({
  index,
  total,
  itemLabel,
  onMoveUp,
  onMoveDown,
  onRemove,
  disabled = false,
}: ReorderButtonsProps) {
  return (
    <div className="flex shrink-0 items-center gap-1">
      <IconTooltipButton
        icon={ArrowUp}
        label={`Move ${itemLabel} up`}
        onClick={onMoveUp}
        isDisabled={disabled || index === 0}
      />
      <IconTooltipButton
        icon={ArrowDown}
        label={`Move ${itemLabel} down`}
        onClick={onMoveDown}
        isDisabled={disabled || index === total - 1}
      />
      <IconTooltipButton
        icon={Trash2}
        label={`Remove ${itemLabel}`}
        onClick={onRemove}
        isDisabled={disabled}
        isDanger
      />
    </div>
  );
}
